export const colors = {
    color: ['#2365C4', '#73CDFC', '#F99248', '#534FCF', '#AAA7F9', '#ACD598', '#6CBA52', '#097C25'],
    textColor: '#88A3B4',
    legendColor: '#607A8D',
    axisLineColor: '#E9EEF2',
    splitLineColor: '#F7F9FA',
    nameTextColor: '#ccc'
};

// 图例翻页样式设置
export const pageIconSetting = {
    pageIconSize: 10
};

export const tooltipStyles = {
    borderColor: 'transparent',
    backgroundColor: 'rgba(255,255,255,.9)',
    textStyle: {
        color: '#012C4B',
        fontWeight: 'bold'
    },
    extraCssText: 'box-shadow: 2px 0px 10px 1px rgba(7,32,69,0.15);'
};



// WEBPACK FOOTER //
// ./src/components/common/echarts/config/config.js